/**
 * 店舗在庫状況ブロック。表は Omni Hub アプリが描画し、テーマは対象店舗の行を消すだけ。
 *
 * アプリはバリアント切替のたびに表を作り直すため、監視は止めない。
 * 一度だけ適用して disconnect すると、切替後に消したはずの店舗が在庫ありで復活する。
 *
 * 行に店舗 ID は出ておらず、突き合わせは店舗名で行うしかない。
 * スマレジ側で店舗名を変えたらメタオブジェクトの値も直す必要がある。
 */
(() => {
  const CONTAINER_ID = 'omni-hub-stock';
  const WRAPPER_SELECTOR = '.c_p-store-inventory-stock';

  function hiddenStores(wrapper) {
    try {
      return new Set(JSON.parse(wrapper.dataset.hiddenStores || '[]'));
    } catch (error) {
      console.error('store-inventory: data-hidden-stores を解釈できなかった', error);
      return new Set();
    }
  }

  function apply(wrapper) {
    const stock = document.getElementById(CONTAINER_ID);
    if (!stock) return;

    if (stock.parentElement !== wrapper) wrapper.appendChild(stock);

    const table = stock.querySelector('table');
    if (!table) return;

    const hidden = hiddenStores(wrapper);
    Array.from(table.rows).forEach((row) => {
      const storeName = row.cells[0]?.textContent.trim();
      if (storeName && hidden.has(storeName)) row.remove();
    });

    // innerHTML の読み戻しは翻訳文の書き方で元と一致しないことがある。差し替え済みは属性で覚える
    const note = table.nextElementSibling;
    const noteHtml = wrapper.dataset.noteHtml;
    if (note && noteHtml && note.dataset.noteApplied === undefined) {
      note.innerHTML = noteHtml;
      note.dataset.noteApplied = '';
    }

    // 行が 1 つも残らなければ表ごと出さない
    wrapper.classList.toggle('is-ready', table.rows.length > 0);
  }

  function observe(wrapper) {
    // アプリが #omni-hub-stock ごと差し替えても追えるよう、テーマ側のラッパーを見る
    new MutationObserver(() => apply(wrapper)).observe(wrapper, {
      childList: true,
      subtree: true,
    });
    apply(wrapper);
  }

  function start() {
    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return;

    if (document.getElementById(CONTAINER_ID)) {
      observe(wrapper);
      return;
    }

    // アプリの描画を待つ間だけ body を見る
    const pending = new MutationObserver(() => {
      if (!document.getElementById(CONTAINER_ID)) return;
      pending.disconnect();
      observe(wrapper);
    });
    pending.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
